import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "button", "shown", "hidden"]

  toggle() {
    this.setVisibility(this.inputTarget.type === "password")
  }

  reset() {
    // A revealed field is plain text, so Turbo would preserve it in its snapshot.
    this.inputTarget.value = ""
    this.setVisibility(false)
  }

  setVisibility(reveal) {
    this.inputTarget.type = reveal ? "text" : "password"
    this.buttonTarget.setAttribute("aria-pressed", String(reveal))
    this.buttonTarget.setAttribute("aria-label", this.buttonTarget.dataset[reveal ? "hideLabel" : "showLabel"])
    this.shownTarget.classList.toggle("hidden", reveal)
    this.hiddenTarget.classList.toggle("hidden", !reveal)
  }
}
